/* eslint-disable  @typescript-eslint/no-explicit-any */

export function doOnceDecorator(fn, context) {
  var result;
  return function () {
    if (fn) {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      result = fn.apply(context || this, args);
      // eslint-disable-next-line no-param-reassign
      fn = context = null;
    }
    return result;
  };
}